import { StoryModel } from '../models/story.model';
import { ChapterModel } from '../models/chapter.model';
import { StoryType } from '../models/story-type.enum';
import { StoryLoadTypeEnum } from '../models/story-load-type.enum';

export class StoryStateModel {
    loading: boolean;
    incoming: {
        id: string,
        type: StoryType
    };
    story?: StoryModel;
    storyId: string; // current storyId
    storyType: StoryType;
    loadType: StoryLoadTypeEnum;
    loadChunks: StoryChunkLoadModel[];
    loadingChunk: StoryChunkLoadModel;
    thumbnailLookup: {
        originalChapterId: string, 
        newChapterId: string, 
        originalStoryId: string
    }[];
}

export class StoryChunkLoadModel {
    storyId: string;
    chapterId: string;
    time?: number;
    objects: string[];
    assetTypes: string[];
    activate: boolean;
    activationConfig?: StoryChapterLoadProtocolModel;
    readyState: {
        model?: boolean;
        animation?: boolean;
    };
}

export class StoryLoadConfigModel {
    targetChapterId:  string;
    targetChapterConfig: {
        global: StoryChapterLoadProtocolModel,
        static: StoryChapterLoadProtocolModel,
        dynamic: StoryChapterLoadProtocolModel
    };
    chapterAssetBundle: boolean;
    sortBy: 'chapter' | 'readyState';
}

export class StoryChapterLoadProtocolModel {
    timeline?: boolean;
    camera?: boolean;
    graph?: boolean;
    properties?: boolean;
    particles?: boolean;
    clipping?: boolean;
    postprocess?: boolean;
    transparencyMode?: boolean;
    labels?: boolean;
}
